import { render, staticRenderFns } from "./add-config.vue?vue&type=template&id=0d03611d"
import script from "./add-config.vue?vue&type=script&lang=js"
export * from "./add-config.vue?vue&type=script&lang=js"
import style0 from "./add-config.vue?vue&type=style&index=0&id=0d03611d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports